module.exports = __webpack_public_path__ + "static/media/WF.e77961ae.svg";